import { Loader2 } from 'lucide-react'
import { cn } from '@lib/utils/helpers'
import { APPLICATION_MODULE_LIST_SPINNER_CLASS } from '../constants'
import type {
  ApplicationListLoadingStateProps,
  ApplicationModalLoadingStateProps,
} from '../types/components'

export function ApplicationListLoadingState({
  testId = 'application-list-loading',
  className,
  message,
}: ApplicationListLoadingStateProps) {
  return (
    <div
      data-testid={testId}
      className={cn('flex flex-col items-center justify-center py-20', className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Loader2
        className={APPLICATION_MODULE_LIST_SPINNER_CLASS}
        data-testid={`${testId}-spinner`}
        aria-hidden
      />
      {message ? (
        <p className="mt-3 text-sm text-slate-600" data-testid={`${testId}-message`}>
          {message}
        </p>
      ) : (
        <span className="sr-only">Loading</span>
      )}
    </div>
  )
}

/** Centered spinner for application modals (EORP / max rent / previous apps parity). */
export function ApplicationModalLoadingState({
  testId = 'application-modal-loading',
  className,
}: ApplicationModalLoadingStateProps) {
  return (
    <div
      data-testid={testId}
      className={cn('flex justify-center py-8', className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Loader2
        className={APPLICATION_MODULE_LIST_SPINNER_CLASS}
        data-testid={`${testId}-spinner`}
        aria-label="Loading"
      />
    </div>
  )
}
